import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import clsx from 'clsx';
import { SeminarCliListItem } from '@/components/modules/pages/seminar/client/List/SeminarCliListItem';
import { TopBaseSlider } from '@/components/modules/pages/top/slider/TopBaseSlider';
import { getScreenValueOfNumber } from '@/utils/style/config';
const sliderSetting = {
    arrows: true,
    infinite: false,
    responsive: [
        {
            breakpoint: getScreenValueOfNumber('md') - 1,
            settings: {
                arrows: false,
                variableWidth: true,
            },
        },
        {
            breakpoint: getScreenValueOfNumber('lg') - 1,
            settings: {
                arrows: false,
                variableWidth: true,
            },
        },
        {
            breakpoint: getScreenValueOfNumber('xl') - 1,
            settings: {
                variableWidth: false,
            },
        },
    ],
    slidesToScroll: 1,
    slidesToShow: 1,
};
/**
 * TOP: コラムのスライダー
 * @param props
 * @returns
 */
export const TopSeminarSlider = (props) => {
    const { className = '', isGuest, isProfessional, items, onClickDocumentLink, onClickSeminarLink, } = props;
    // slick内の要素をすべてheight100%にし、下揃えにするための設定（一部に「注目のセミナー」が存在する場合、要素が不揃いになってしまうため）
    const slickCss = css `
    .slick-track {
      margin-left: 0;
      display: flex !important;
    }
    .slick-slide {
      height: inherit !important;

      > div {
        display: flex;
        height: 100%;
      }
    }
  `;
    return (_jsx("div", Object.assign({ className: className, css: slickCss }, { children: _jsx(TopBaseSlider, Object.assign({ setting: sliderSetting }, { children: items.map((item, index) => (_jsx("div", Object.assign({ className: clsx('px-4 lg:px-16 py-8 h-full') }, { children: _jsx("div", Object.assign({ className: clsx('w-[305px] md:w-full h-full') }, { children: _jsx(SeminarCliListItem, { className: clsx('flex flex-col', 'h-full'), innerClassName: clsx('grow-[1]'), isGuest: isGuest, isPreview: false, isProfessional: isProfessional, isShowRecommended: false, onClickDocumentLink: onClickDocumentLink, onClickSeminarLink: onClickSeminarLink, seminar: item }, `${index + 1}`) })) }), item.id))) })) })));
};
